export const Level2 = () => <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.125 28.7856H28.7857" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M19.2114 28.7856H22.8721" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M17.0714 20.7322H11.2143V28.7858H17.0714V20.7322Z" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
